// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "(max-width: 768px)";
var _3 = "wrapper-2CxOq";
var _4 = "info-uh-0R";
var _5 = "airport-zVpbt";
var _6 = "time-3mJxm";
var _7 = "city-ofywI";
var _8 = "time_iata-2PyyF";
var _9 = "date-3KO1x";
var _a = "date_icon-nJXpi";
var _b = "terminal-dBe0Q";
var _c = "terminal_city-1KRp-";
var _d = "terminal_iata-2fTyV";
var _e = "terminal_icon-2V-Ub";
var _f = "terminal_airport-39ihL";
var _10 = "terminal_airportTerminal-1N6wT";
var _11 = "terminal_number-1nsMN";
var _12 = "weather-3s4Ma";
var _13 = "weather_gradient-12NRM";
var _14 = "weather_placeholder-1XMlR";
var _15 = "weather_wrapper-1X3N-";
var _16 = "flight_icon-2ts-C";
var _17 = "weather_temp-1SJ5A";
var _18 = "isMobile-2SU6g";
export { _1 as "__esModule", _2 as "tabletMiddle", _3 as "wrapper", _4 as "info", _5 as "airport", _6 as "time", _7 as "city", _8 as "time_iata", _9 as "date", _a as "date_icon", _b as "terminal", _c as "terminal_city", _d as "terminal_iata", _e as "terminal_icon", _f as "terminal_airport", _10 as "terminal_airportTerminal", _11 as "terminal_number", _12 as "weather", _13 as "weather_gradient", _14 as "weather_placeholder", _15 as "weather_wrapper", _16 as "flight_icon", _17 as "weather_temp", _18 as "isMobile" }
export default { "__esModule": _1, "tabletMiddle": _2, "wrapper": _3, "info": _4, "airport": _5, "time": _6, "city": _7, "time_iata": _8, "date": _9, "date_icon": _a, "terminal": _b, "terminal_city": _c, "terminal_iata": _d, "terminal_icon": _e, "terminal_airport": _f, "terminal_airportTerminal": _10, "terminal_number": _11, "weather": _12, "weather_gradient": _13, "weather_placeholder": _14, "weather_wrapper": _15, "flight_icon": _16, "weather_temp": _17, "isMobile": _18 }
